import React from "react";
import { useSoundEmissionColorBar } from "../CustomHooks";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";

const SoundEmissionColorBar = () => {
  const { minValue, maxValue, isVisible } = useSoundEmissionColorBar();

  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.SOUND_EMISSION}
      category="Sound Emission"
      subcategory="Heat pump candidates"
      unit="Max allowable Lw [dB(A)]"
      dataMin={minValue}
      dataMax={maxValue}
      isVisible={isVisible}
    />
  );
};

export default SoundEmissionColorBar;

